import AdminLeftNav from './AdminLeftNav.js';

export default AdminLeftNav;
